export enum MonitoringType {
  ping = 'ping',
  http = 'http',
  resources = 'resources',
  mongodb = 'mongodb',
  sqldb = 'sqldb',
}
